import * as React from 'react';
import classnames from 'classnames';

const ProductDetailStack = ({ children , className , spacing ='full' ,  })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames('product-detail-stack', {
            'product-detail-stack--full-spacing': spacing === 'full',
            'product-detail-stack--half-spacing': spacing === 'half'
        }, className)
    }, children);
};

export { ProductDetailStack };
//# sourceMappingURL=ProductDetailStack.js.map
